module.exports = __webpack_public_path__ + "img/RW.04c2272b.svg";